var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _vm.puedeIngresar || _vm.puedeEgresar
              ? _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.crear }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _c("span", [_vm._v("Nuevo")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-2" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("div", { staticClass: "form-inline__title" }, [
                  _vm._v("\n              Fecha\n            ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-inline__content" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipoFecha,
                          expression: "form.tipoFecha"
                        }
                      ],
                      attrs: { type: "radio", value: "H" },
                      domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipoFecha", "H")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Hoy")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipoFecha,
                          expression: "form.tipoFecha"
                        }
                      ],
                      attrs: { type: "radio", value: "A" },
                      domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipoFecha", "A")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Ayer")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipoFecha,
                          expression: "form.tipoFecha"
                        }
                      ],
                      attrs: { type: "radio", value: "P" },
                      domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipoFecha", "P")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Personalizado")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipoFecha == "P",
                          expression: "form.tipoFecha == 'P'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "desde",
                              locale: "es",
                              "only-date": "",
                              "no-label": "",
                              noClearButton: "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD",
                              formatted: "YYYY-MM-DD",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fechaDesde,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fechaDesde", $$v)
                              },
                              expression: "form.fechaDesde"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Desde:")])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipoFecha == "P",
                          expression: "form.tipoFecha == 'P'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "hasta",
                              locale: "es",
                              "only-date": "",
                              "no-label": "",
                              noClearButton: "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD",
                              formatted: "YYYY-MM-DD",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fechaHasta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fechaHasta", $$v)
                              },
                              expression: "form.fechaHasta"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Hasta:")])
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("div", { staticClass: "form-inline__title" }, [
                  _vm._v("Estado")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-inline__content" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { type: "radio", value: "A" },
                      domProps: { checked: _vm._q(_vm.form.estado, "A") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado", "A")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Activos")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { type: "radio", value: "I" },
                      domProps: { checked: _vm._q(_vm.form.estado, "I") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado", "I")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Inactivos")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { type: "radio", value: "T" },
                      domProps: { checked: _vm._q(_vm.form.estado, "T") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado", "T")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Todos")])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "tipo_movimiento_filter",
                        options: _vm.tiposMovimiento,
                        index: "value"
                      },
                      model: {
                        value: _vm.form.tipo_movimiento,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "tipo_movimiento", $$v)
                        },
                        expression: "form.tipo_movimiento"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "tipo_movimiento_filter" } }, [
                      _vm._v("Tipo de movimiento")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "tipo_caja_filter",
                        options: _vm.tiposCaja,
                        index: "value"
                      },
                      model: {
                        value: _vm.form.tipo_caja,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "tipo_caja", $$v)
                        },
                        expression: "form.tipo_caja"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "tipo_caja" } }, [
                      _vm._v("Tipo de caja")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "rutas_filter",
                        options: _vm.rutas,
                        label: "descripcion",
                        index: "id",
                        selectedLabel: "Seleccionado",
                        selectLabel: "Presiona enter para seleccionar",
                        deselectLabel: "Presiona enter para eliminar",
                        multiple: ""
                      },
                      model: {
                        value: _vm.form.rutas_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rutas_id", $$v)
                        },
                        expression: "form.rutas_id"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "ruta_id" } }, [_vm._v("Ruta")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        id: "buscar",
                        placeholder: "Realice una consulta..."
                      },
                      model: {
                        value: _vm.form.searchP,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "searchP", $$v)
                        },
                        expression: "form.searchP"
                      }
                    },
                    [_vm._v("\n              Buscar\n            ")]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "movimientos",
              attrs: {
                createButton: false,
                editButton: _vm.puedeEditarMovimiento,
                buscarButton: false,
                deleteButton: "",
                path: _vm.path,
                columns: _vm.columns,
                params: _vm.form
              },
              on: { editar: _vm.editar, eliminar: _vm.eliminar }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "movimiento",
            scrollable: "",
            resizable: "",
            reset: "",
            adaptive: "",
            height: "auto",
            width: "60%",
            clickToClose: false
          }
        },
        [
          _c("movimiento-prestamo", {
            attrs: {
              tiposCaja: _vm.tiposCaja,
              tiposMovimiento: _vm.tiposMovimiento,
              rutas: _vm.rutas
            },
            on: { cancelar: _vm.cancelar, saved: _vm.saved },
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Movimientos de caja")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dbca9c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dbca9c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/movimientos/ListaMovimientosPrestamos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2dbca9c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/movimientos/ListaMovimientosPrestamos.vue
// module chunks = 0